import React, { useEffect } from "react";
import { Editor } from "react-draft-wysiwyg";
import { convertToRaw, convertFromHTML } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { useDispatch, useSelector } from "react-redux";
import {
  setNewSmsTemplateMessage,
  setNewSmsTemplatePlaintext,
  setNewTemplateContent,
  setNewTemplateHTMLContent,
  setNewTemplateType,
} from "../../../../../redux/actions/new-template";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();
  const content = useSelector(
    (state) => state.newTemplate.smsTemplate.messageData
  );

  const handleEditorChange = (state) => {
    dispatch(setNewSmsTemplateMessage(state));
    dispatch(
      setNewSmsTemplatePlaintext(
        state.getCurrentContent().getPlainText("\u0001")
      )
    );
  };

  return (
    <div
      className="tab-pane fade show active"
      id="nav-sms"
      role="tabpanel"
      aria-labelledby="nav-sms-tab"
    >
      <div className="tab-content-container sms">
        <Editor
          wrapperClassName="template-composer-wrapper"
          editorClassName="editor-composer-wrapper"
          toolbarClassName="toolbar-composer-wrapper"
          placeholder="Skriv her"
          toolbar={{ options: [] }}
          editorState={content}
          onEditorStateChange={(state) => handleEditorChange(state)}
        />
      </div>
    </div>
  );
};

export default Index;
